// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import toasts, { addToast } from 'helpers/toasts';

/**
 * Shows an assistant warning or failure as a toast that closes by itself, since the toasts
 * cover the assistant's header, and not again while the same one is still shown.
 */
export const addToolCallToast = (intent: 'warning' | 'danger', message: string) => {
    if (toasts().some(toast => toast.intent === intent && toast.message === message)) {
        return;
    }
    addToast({ intent, message, autoClosable: true });
};
